module.exports = __webpack_public_path__ + "static/media/sinistros.ff4ce3c1.png";